import React, { useState, useEffect, useRef } from 'react';
import './OTPInput.scss';
import { useDispatch, useSelector } from 'react-redux';
import { verifyOtp } from '../../../Views/beforeAuth/LoginView/redux/actionCreator';
import { useNavigate } from 'react-router-dom';
import { Pathname } from '../../../Router/Pathname';

const OTPInput = ({ otpLength, onOtpChange }) => {
    const navigateTo = useNavigate();

    const [otpValues, setOtpValues] = useState(Array(otpLength).fill(''));
    const [isSuccess, setIsSuccess] = useState(false);
    const { otp } = useSelector((store) => store);
    const { error, loading, otpInfo } = otp;
    const dispatch = useDispatch();
    // console.log('error', otp);
    const data = useSelector(
        (state) => state?.otp?.otpVerification?.payload?.customer?.is_onboarded
    );
    const inputRefs = useRef([]);

    useEffect(() => {
        inputRefs.current[0]?.focus();
    }, []);

    useEffect(() => {
        const validateOtp = async () => {
            const enteredOtp = otpValues.join('');
            if (enteredOtp.length === otpLength) {
                try {
                    const res = await dispatch(
                        verifyOtp({
                            phoneNumber: otpInfo?.payload?.payload?.to,
                            otp: enteredOtp,
                        })
                    );

                    if (res.payload?.success) {
                        setIsSuccess(true);
                        onOtpChange(true);
                        localStorage.setItem('t_id', res?.payload?.payload?.access_token);
                    } else {
                        setIsSuccess(false);
                        onOtpChange(false);
                    }
                } catch (error) {
                    console.error('Error validating OTP:', error);
                }
            }
        };

        validateOtp();
    }, [otpValues.join('')]);

    const handleOtpChange = (index, value) => {
        if (/^\d$/.test(value)) {
            const newOtpValues = [...otpValues];
            newOtpValues[index] = value;
            setOtpValues(newOtpValues);

            if (index < otpLength - 1) {
                inputRefs.current[index + 1]?.focus();
            }
        } else if (value === '') {
            const newOtpValues = [...otpValues];
            newOtpValues[index] = '';
            setOtpValues(newOtpValues);
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace') {
            const newOtpValues = [...otpValues];

            if (otpValues[index] === '') {
                if (index > 0) {
                    inputRefs.current[index - 1]?.focus();
                    newOtpValues[index - 1] = '';
                    setOtpValues(newOtpValues);
                }
            } else {
                newOtpValues[index] = '';
                setOtpValues(newOtpValues);
            }
        }
    };

    return (
        <div className="otp-input-container">
            {otpValues.map((value, index) => (
                <input
                    key={index}
                    ref={(ref) => (inputRefs.current[index] = ref)}
                    type="text"
                    value={value}
                    onChange={(e) => handleOtpChange(index, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    className={`otp-input ${isSuccess ? 'success' : ''} ${
                        !isSuccess && value ? 'error' : ''
                    }`}
                    maxLength={1}
                    inputMode="numeric"
                />
            ))}
        </div>
    );
};

export default OTPInput;
